export const IMPORT_VERSIONS_ACTIONS = {
	RESET_IMPORT_VERSIONS_LIST: "RESET_IMPORT_VERSIONS_LIST",
	FETCH_IMPORT_VERSIONS_AJAX: "FETCH_IMPORT_VERSIONS_AJAX",
	FETCH_IMPORT_VERSIONS_SUCCESS: "FETCH_IMPORT_VERSIONS_SUCCESS",
	FETCH_IMPORT_VERSIONS_ERROR: "FETCH_IMPORT_VERSIONS_ERROR",

	IMPORT_VERSIONS_AJAX: "IMPORT_VERSIONS_AJAX",
	IMPORT_VERSIONS_SUCCESS: "IMPORT_VERSIONS_SUCCESS",
	IMPORT_VERSIONS_ERROR: "IMPORT_VERSIONS_ERROR",

	CONFIRM_VERSION_IMPORT: "CONFIRM_VERSION_IMPORT",
	CONFIRM_VERSION_IMPORT_SUCCESS: "CONFIRM_VERSION_IMPORT_SUCCESS",
	CONFIRM_VERSION_IMPORT_ERROR: "CONFIRM_VERSION_IMPORT_ERROR",
};
